<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                         <el-input
                            size="small"
                            style="width:300px;"
                            placeholder="请输入姓名 / 手机 / QQ"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="用户状态">
                            <el-option key="1" label="正常" value="1"> </el-option>
                            <el-option key="2" label="封停" value="2"> </el-option>
                        </el-select>
                        <el-checkbox  style="margin-left:30px;" v-model="queryModel.isPromoter">推广员</el-checkbox>
                        <el-checkbox  style="" v-model="queryModel.hasCredits">信用额度</el-checkbox>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <b style="font-size:13px;margin-left:10px">余额总计：</b>
                        <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{balance.toFixed(2)}}</el-tag>
                        <b style="font-size:13px;margin-left:10px">已使用信用额度总计：</b>
                        <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{useCredits.toFixed(2)}}</el-tag>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                        width="60px"
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                        width="70px"
                            prop="Name"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                            prop="Email"
                            label="邮箱"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            label="余额">
                            <template slot-scope="scope">
                                <el-link icon="el-icon-money" type="primary">￥{{scope.row.Balance}}</el-link>

                                <!-- <el-link @click="setBalance(scope.row)" icon="el-icon-money" type="primary">￥{{scope.row.Balance}}</el-link> -->
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="收款">
                            <template slot-scope="scope">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <div >
                                            <el-button  @click="changeReceivePayment(scope.row,0,'暂无')" size="mini" >暂无</el-button>
                                            <el-button v-for="item in receivePaymentList" :key="item.Id" @click="changeReceivePayment(scope.row,item.Id,item.Name)" size="mini" >{{item.Name}}</el-button>
                                        </div>
                                        <el-tag  slot="reference"  size="mini">{{scope.row.ReceivePaymentName?scope.row.ReceivePaymentName:'暂无'}}</el-tag>
                                    </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="支付宝">
                            <template slot-scope="scope">
                                    <el-popover
                                        placement="bottom"
                                        trigger="hover">
                                        <div >
                                            <el-button @click="changeReceiveAlipay(scope.row,0,'暂无')" size="mini" >暂无</el-button>
                                            <el-button v-for="item in receiveAlipayList" :key="item.Id" @click="changeReceiveAlipay(scope.row,item.Id,item.AccountName)" size="mini" >{{item.AccountName}}</el-button>
                                        </div>
                                        <el-tag  slot="reference"  size="mini">{{scope.row.ReceiveAlipayName?scope.row.ReceiveAlipayName:'暂无'}}</el-tag>
                                    </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="信用额度">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.Advance==0" @click="openCredits(scope.row)" icon="el-icon-bank-card" type="info">暂无</el-link>
                                <el-link v-else icon="el-icon-bank-card" @click="closeCredits(scope.row)" type="primary">￥{{scope.row.Advance}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="赔付账户">
                            <template slot-scope="scope">
                                <el-link @click="setPayoutAction(scope.row)" icon="el-icon-money" type="primary">￥{{scope.row.Payout}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="130"
                            label="推荐人1">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.Referrer==0" @click="setReferrer(scope.row)" icon="el-icon-user-solid" type="info">暂无</el-link>
                                <el-link v-else icon="el-icon-user-solid" @click="clearReferrer(scope.row)" type="primary">{{scope.row.ReferrerPhone}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="130"
                            label="推荐人2">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.ReferrerExtra==0"  @click="setReferrerExtra(scope.row)" icon="el-icon-s-custom" type="info">暂无</el-link>
                                <el-link v-else icon="el-icon-s-custom" @click="clearReferrerExtra(scope.row)" type="primary">{{scope.row.ReferrerExtraPhone}}</el-link>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="推广提成">
                            <template slot-scope="scope">
                                <el-link @click="setCommissionAction(scope.row)" v-if="scope.row.CommissionType==0"  type="info">未设置</el-link>
                                <template v-else>
                                    <el-tag class="tag_btn" @click="setCommissionAction(scope.row)" v-if="scope.row.CommissionType==1" size="mini" effect="dark">{{scope.row.CommissionValue}}%</el-tag>
                                    <el-tag class="tag_btn" @click="setCommissionAction(scope.row)" v-else size="mini"  effect="dark">￥{{scope.row.CommissionValue}}</el-tag>
                                    <el-tag class="tag_btn" @click="copy(scope.row)"  size="mini" effect="dark" type="info">
                                        <i  class="el-icon-copy-document"></i>
                                    </el-tag>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="注册时间">
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.Status==1">正常</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else>封停</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="130"
                            label="备注">
                            <template slot-scope="scope">
                                <template>
                                    <el-tooltip  class="item" effect="dark" placement="left">
                                        <div slot="content" style="width:100px;line-height:18px">{{scope.row.Remark}}</div>
                                        <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Remark}}</div>
                                    </el-tooltip>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="100px"
                            label="操作"
                            v-if="manger.Role==1">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="修改备注" placement="bottom">
                                        <el-button  size="mini"  type="primary" @click="chuli(scope.row)" icon="el-icon-edit" circle></el-button>
                                    </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="封停用户，无法登陆" placement="bottom">
                                    <el-button type="danger" size="mini" @click="deactivate(scope.row)"  icon="el-icon-close" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-else effect="dark" content="解封用户，正常使用" placement="bottom">
                                    <el-button type="success" size="mini" @click="enable(scope.row)"  icon="el-icon-check" circle></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="配置提成" :visible.sync="setCommission" width="500px">
            <el-form   label-width="100px">
                <el-form-item label="类型：" prop="Title">
                    <el-radio-group v-model="setCommissionModel.commissionType">
                        <el-radio :label="0">关闭</el-radio>
                        <el-radio :label="1">百分比</el-radio>
                        <el-radio :label="2">固定金额</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="setCommissionModel.commissionType>0" :label="setCommissionModel.commissionType==1?'提成百分比：':'提成金额：'" >
                    <el-input v-model="setCommissionModel.commissionValue" :placeholder="setCommissionModel.commissionType==1?'%':'￥'"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setCommission = false">取 消</el-button>
                <el-button type="primary" @click="setCommissionForm">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改余额" :visible.sync="dialogFormVisible" width="400px">
            <el-form   label-width="80px">
                <el-form-item label="类型：" prop="Title">
                      <el-radio-group v-model="setType">
                            <el-radio :label="1">充值</el-radio>
                            <el-radio :label="2">扣款</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" >
                    <el-input v-model="setBalanceModel.money" placeholder="￥"></el-input>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input v-model="setBalanceModel.remark" placeholder="请输入备注信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="开通信用额度" :visible.sync="openCreditsVisible" width="400px">
            <el-form   label-width="120px">
                <el-form-item label="开通额度：" >
                    <el-input v-model="openCreditsModel.credits" placeholder="￥"></el-input>
                </el-form-item>
                <el-form-item label="过期时间：" >
                    <el-date-picker v-model="openCreditsModel.creditsExpiration" type="date" placeholder="选择过期日期"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="openCreditsVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveCredits">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="降权赔付" :visible.sync="setPayout" width="400px">
            <el-form  label-width="80px">
                <el-form-item label="类型：">
                      <el-radio-group v-model="setPayoutType">
                            <el-radio :label="1">充值</el-radio>
                            <!-- <el-radio :label="2">扣款</el-radio> -->
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" >
                    <el-input v-model="setPayoutModel.money" placeholder="￥"></el-input>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input v-model="setPayoutModel.remark" placeholder="请输入备注信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setPayout = false">取 消</el-button>
                <el-button type="primary" @click="submitPayoutForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-drawer
        title="推广明细"
        :visible.sync="drawer"
        direction="btt"
        size="80%">
            <div style="padding-left:20px;padding-right:20px">
                    <el-divider content-position="left">
                        {{drawerName}} 的推广佣金
                        <el-date-picker
                        style="margin-left:20px;width:250px"
                        size="small"
                        v-model="queryOffline.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="seeOffline(scopeRow)">
                        </el-date-picker>
                    </el-divider>
                    <el-table
                    :data="offlines"
                    style="width: 100%">
                        <el-table-column
                                prop="Name"
                                label="用户名称">
                        </el-table-column>   
                        <el-table-column
                                prop="Phone"
                                label="手机号">
                        </el-table-column>
                        <el-table-column
                                label="店铺数量">
                                <template slot-scope="scope">
                                    <el-tag size="mini" effect="dark">{{scope.row.ShopCount}}</el-tag>
                                </template>
                        </el-table-column>
                        <el-table-column
                                label="订单数量">
                                <template slot-scope="scope">
                                    <el-tag size="mini" type="danger" effect="dark">{{scope.row.Count}}</el-tag>
                                </template>
                        </el-table-column>
                        <el-table-column
                                label="总佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.Money.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="CreateTime"
                                label="创建时间">
                        </el-table-column>   
                        <el-table-column
                                prop="LastLoginTime"
                                label="最后登录时间">
                        </el-table-column>   
                        <el-table-column
                        label="状态">
                            <template slot-scope="scope">
                                <el-tag effect="dark" v-if="scope.row.Status==2" type="danger" size="mini">禁用</el-tag>
                                <el-tag effect="dark" type="success" v-else size="mini" >正常</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                
            </div>
        </el-drawer>

        <el-dialog title="修改备注" :visible.sync="editVisible" width="600px">
            <div style="margin-top:20px;">
                <el-input
                style="width:550px"
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
                v-model="setModel.Remark">
                </el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {memberSetReceiveAlipay, receivePaymentGetAlipay, memberSetReceivePayment, receivePaymentGet,memberGet,memberSetStatus,memberOpenCredits,memberCloseCredits, memberSetReferrer,memberSetReferrerExtra,memberClearReferrer,
memberClearReferrerExtra,memberAddBalance,memberReduceBalance,memberAddPayout,memberReducePayout,memberSetCommission,memberGetOffline,memberSetRemark} from '@/request.js'

export default {
    props:{
    },
    data(){
        return {
            manager:{},
            receiveAlipayList:[],
            receivePaymentList:[],
            openCreditsModel:{
                id:0,
                creditsExpiration:'',
                credits:0,
            },
            openCreditsVisible:false,
            copyMsg:" http://xz.12zui.cn/#/register?code=",
            scopeRow:{},
            drawerName:"",
            drawer:false,
            queryOffline:{
                createTimes:[]
            },
            setCommission:false,
            setCommissionModel:{
                id:0,
                commissionType:0,
                commissionValue:0,
            },
            setPayoutType:1,
            setPayoutModel:{
                money:0,
                remark:"",
                id:0,
            },
            setPayout:false,
            setType:1,
            setBalanceModel:{
                money:0,
                remark:"",
                id:0,
            },
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                isPromoter:false,
                hasCredits:false,
            },
            tableData:[],
            setBalanceRow:{},
            offlines:[],
            useCredits:0,
            balance:0,
            setModel:{
                Remark:"",
            },
            editVisible:false,
            setRow:{},
        }
    },
    created(){
         this.manger=JSON.parse(localStorage.getItem("manger"));
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        console.log(this.manger);
        var date=new Date();
        date.setDate(1);
        this.queryOffline.createTimes.push(date);
        date=new Date();
        var currentMonth=date.getMonth();
        var nextMonth=++currentMonth;
        var nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1);
        var oneDay=1000*60*60*24;
        this.queryOffline.createTimes.push(new Date(nextMonthFirstDay-oneDay));
        receivePaymentGet({},(res)=>{
            this.receivePaymentList=res.Result;
        })
        receivePaymentGetAlipay({},(res)=>{
            this.receiveAlipayList=res.Result;
        })
    },
    methods: {
        chuli(scope){
           this.setModel.Remark=scope.Remark;
           this.setModel.Id=scope.Id;
           this.editVisible=true;
           this.setRow=scope;
       },
        changeReceiveAlipay(scope,id,name){
            memberSetReceiveAlipay({memberId:scope.Id,receivePaymentId:id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    scope.ReceiveAlipayId=id;
                    scope.ReceiveAlipayName=name;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        changeReceivePayment(scope,id,name){
            memberSetReceivePayment({memberId:scope.Id,receivePaymentId:id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    scope.ReceivePaymentId=id;
                    scope.ReceivePaymentName=name;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        copy(scope){
            var that=this;
            this.$copyText(this.copyMsg+scope.InvitationCode).then(function () {
                that.$message({
                    message: '复制推广链接成功',
                    type: 'success'
                });
            }, function (e) {
                console.log(e);
            })
        },
        seeOffline(scope){
            memberGetOffline(
                {
                    createTimes:this.queryOffline.createTimes==null?"[]":JSON.stringify(this.queryOffline.createTimes),
                    memberId:scope.Id,
                },(res)=>{
                    this.offlines=res.Result;
                }
            )
            this.scopeRow=scope;
            this.drawerName=scope.Phone;
            this.drawer=true;
        },
        setCommissionForm(){
            var commissionValue=this.setCommissionModel.commissionValue;
            if(commissionValue==""||isNaN(commissionValue)){
                this.$message({
                    message: '请填写正确的提成值',
                    type: 'warning'
                });
                return;
            }
            memberSetCommission(this.setCommissionModel,(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '配置推广提成成功',
                        type: 'success'
                    });
                    this.setBalanceRow.CommissionType=this.setCommissionModel.commissionType;
                    this.setBalanceRow.CommissionValue=this.setCommissionModel.commissionValue;
                    this.setCommission=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        setCommissionAction(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.setCommissionModel.commissionType=scope.CommissionType;
            this.setCommissionModel.commissionValue=scope.CommissionValue;
            this.setCommissionModel.id=scope.Id;
            this.setCommission=true;
            this.setBalanceRow=scope;
        },
        submitPayoutForm(){
            var money=this.setPayoutModel.money;
            if(money==""||isNaN(money)){
                this.$message({
                    message: '请填写正确的金额',
                    type: 'warning'
                });
                return;
            }
            if(this.setPayoutModel.remark==""){
                this.$message({
                    message: '请填写备注',
                    type: 'warning'
                });
                return;
            }
            if(parseFloat(money)<=0){
                this.$message({
                    message: '金额必须大于零',
                    type: 'warning'
                });
                return;
            }
            if(this.setPayoutType==1){
                memberAddPayout(this.setPayoutModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '充值赔付账户成功',
                            type: 'success'
                        });
                        this.setBalanceRow.Payout+=parseFloat(this.setPayoutModel.money);
                        this.setPayout=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }else{
                memberReducePayout(this.setPayoutModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '扣款成功',
                            type: 'success'
                        });
                        this.setBalanceRow.Payout-=parseFloat(this.setPayoutModel.money);
                        this.setPayout=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }
        },
        setPayoutAction(scope){
            if(this.manger.Role!=1&&this.manger.Role!=3){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.setPayoutModel.id=scope.Id;
            this.setPayoutModel.remark="";
            this.setPayoutModel.money=0;
            this.setPayout=true;
            this.setBalanceRow=scope;
        },
        submitForm(){
            var money=this.setBalanceModel.money;
            if(money==""||isNaN(money)){
                this.$message({
                    message: '请填写正确的金额',
                    type: 'warning'
                });
                return;
            }
            if(parseFloat(money)<=0){
                this.$message({
                    message: '金额必须大于零',
                    type: 'warning'
                });
                return;
            }
            if(this.setType==1){
                memberAddBalance(this.setBalanceModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '充值成功',
                            type: 'success'
                        });
                        this.setBalanceRow.Balance+=parseFloat(this.setBalanceModel.money);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }else{
                memberReduceBalance(this.setBalanceModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '扣款成功',
                            type: 'success'
                        });
                        this.setBalanceRow.Balance-=parseFloat(this.setBalanceModel.money);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }
        },
        setBalance(scope){
            if(this.manger.Role!=1&&this.manger.Role!=3){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.setBalanceModel.id=scope.Id;
            this.setBalanceModel.remark="";
            this.setBalanceModel.money=0;
            this.dialogFormVisible=true;
            this.setBalanceRow=scope;
        },
        setReferrer(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$prompt('请填写邀请人手机号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            inputErrorMessage: '请输入正确的手机号'
            }).then(({ value }) => {
                memberSetReferrer({id:scope.Id,phone:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        scope.Referrer=res.Result;
                        scope.ReferrerPhone=value;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        clearReferrer(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认解除该推荐人关联吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                memberClearReferrer({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '解除成功',
                            type: 'success'
                        });
                        scope.Referrer=0;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        setReferrerExtra(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$prompt('请填写邀请人2手机号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            inputErrorMessage: '请输入正确的手机号'
            }).then(({ value }) => {
                memberSetReferrerExtra({id:scope.Id,phone:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        scope.ReferrerExtra=res.Result;
                        scope.ReferrerExtraPhone=value;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        clearReferrerExtra(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认解除该推荐人关联吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                memberClearReferrerExtra({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '解除成功',
                            type: 'success'
                        });
                        scope.ReferrerExtra=0;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        saveCredits(){
            memberOpenCredits({id:this.openCreditsModel.id,credits:this.openCreditsModel.credits, creditsExpiration:this.openCreditsModel.creditsExpiration},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '开通成功',
                        type: 'success'
                    });
                    this.openCreditsVisible=false;
                    this.scopeRow.Advance=this.openCreditsModel.credits;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        openCredits(scope){
            if(this.manger.Role!=1&&this.manger.Role!=3){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.scopeRow=scope;
            this.openCreditsModel.id=scope.Id;
            this.openCreditsVisible=true;
        },
        closeCredits(scope){
            if(this.manger.Role!=1&&this.manger.Role!=3){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认关闭信用额度吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                memberCloseCredits({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '关闭成功',
                            type: 'success'
                        });
                        scope.Advance=0;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        enable(scope){
            this.$confirm('确认解封该用户吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                memberSetStatus({id:scope.Id,status:1},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '解封成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        deactivate(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认封停该用户吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                memberSetStatus({id:scope.Id,status:2},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '封停成功',
                            type: 'success'
                        });
                        scope.Status=2;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        setRemark(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$prompt('请填写备注', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            }).then(({ value }) => {
                memberSetRemark({id:scope.Id,Remark:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        scope.Remark=value;
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },

        submitEdit(){
           if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            console.log(this.setModel.Remark);
            memberSetRemark({id:this.setModel.Id,Remark:this.setModel.Remark},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '处理成功',
                        type: 'success'
                    });
                    
                    this.editVisible=false;
                    this.setRow.Remark=this.setModel.Remark;
                }else{
                    this.$message.error(res.Message);
                }
           });
       },

        query(){
            this.isLoading=true;
            memberGet({
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                isPromoter:this.queryModel.isPromoter,
                hasCredits:this.queryModel.hasCredits,
            },(res)=>{
                this.tableData=res.Result.List;
                this.useCredits=res.Result.UseCredits;
                this.balance=res.Result.Balance;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                status:"",
                isPromoter:false,
                hasCredits:false,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style scoped>
.tag_btn{
    cursor: pointer;
}
</style>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>